/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Org_Access_DeniedInputs */

const cs_auth_org_access_denied = /** @type {(inputs: Auth_Org_Access_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přístup k organizaci je pozastaven (licence nebo předplatné). Kontaktujte franchisora.`)
};

const en_auth_org_access_denied = /** @type {(inputs: Auth_Org_Access_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organization access is suspended (license or subscription). Contact your franchisor.`)
};

/**
* | output |
* | --- |
* | "Organization access is suspended (license or subscription). Contact your franchisor." |
*
* @param {Auth_Org_Access_DeniedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_org_access_denied = /** @type {((inputs?: Auth_Org_Access_DeniedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Org_Access_DeniedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_org_access_denied(inputs)
	return cs_auth_org_access_denied(inputs)
});